import { TNestedGenericId, Utils } from '@microfrontends/react-components'

export enum ESearchSetting {
    DEFAULT = 0,
    RELEVANT = 1
}

export type TAuthUser = {
    id: number
    resumeId: number
    userName: string
    userId: number
    firstName: string
    lastName: string
    profilePicture: string
    jobTitle: string
    accessToken: string
    refreshToken: string
    industryList: Array<any>
    jobLevelId: Array<number>
    locationList: Array<number>
    jobFunction: TNestedGenericId[]
    userIP: string
    expectedSalary: number
    phone: string
    summary: string
    yearExperience: number
    searchSettingSortType: ESearchSetting
}

export type TTokenValidationData = {
    data: [
        {
            type: 'SessionWS'
            attributes: {
                isExpireSessionWS: boolean
                timeExpireAccessToken: number
                timeExpireRefreshToken: number
            }
        }
    ]
}

class UserService {
    private _user: Promise<TAuthUser | null>
    private _userResolver: ((value: PromiseLike<TAuthUser | null> | TAuthUser | null) => void) | null = null

    constructor() {
        this._user = new Promise<TAuthUser | null>((resolve) => {
            this._userResolver = resolve
        })
    }

    setUser(user: null | TAuthUser) {
        this._userResolver && this._userResolver(user)
    }

    /**
     * This will return a user promise, and will resolve to `TAuthUser` or `null` if user has not signed in
     */
    getUser(): Promise<TAuthUser | null> {
        return this._user
    }

    async getAccessToken(): Promise<string> {
        const user = await this.getUser()
        return user?.accessToken || ''
    }

    /**
     * This method is called once in Master Layout when the component mounted
     */
    async authenticate(jsToken: string, wsToken: string): Promise<TAuthUser | null> {
        const response = await fetch(process.env.NEXT_PUBLIC_AUTH_API as string, {
            method: 'post',
            headers: {
                'Content-Type': 'application/vnd.api+json',
                Accept: 'application/vnd.api+json'
            },
            body: JSON.stringify({ jsToken, wsToken })
        })

        // If success
        if (response.status === 200) {
            const responseData = await response.json()

            const singleData = responseData.data[0]

            const user: TAuthUser = {
                ...singleData.id,
                ...singleData.attributes
            }

            this.setUser(user)
            return user
        } else {
            // If fail
            this.setUser(null)
            return null
        }
    }
}

export default new UserService()
